import { FC } from 'react'
import styles from 'components/features/pfm/TransactionNarrowGroup/TransactionNarrowGroup.styl'
import cn from 'classnames'

type TransactionNarrowGroupProps = {
  className?: string
}

export const TransactionNarrowGroup: FC<TransactionNarrowGroupProps> = (props) => {
  const { children, className } = props

  return (
    <div className={ cn(styles.transactionNarrowGroup, className) }>
      <div>
        { children }
      </div>
    </div>
  )
}
